import { type yup } from '@framework/validation/initYup.ts';
import { getWidgetName } from '../../../../../validator/form-builder/getWidgetName.ts';
import { type IInputWidget } from '../IInputWidget.ts';

export function createCommonFormSchema<W extends IInputWidget>(
  schema: yup.AnySchema,
  widget: W,
) {
  return { [getWidgetName(widget)]: schema };
}
